module.exports = __webpack_public_path__ + "media/images/country_flags/pf-feb14bd23cafcf593d8e0fcd9332413d.png";